import { ObservableArray, View } from "binder"
import { FormBuilderComponentView, FormBuilderElement } from "src/formBuilder/structure/element";
import { GridViewModel } from "./grid-viewModel"

export class GridView extends FormBuilderComponentView<GridViewModel>{
    GetViewUniqueId(): string {
        return "V-05B4D76B-2A4D-4760-8DE5-19997B54AE63"
    }
    loadHtml(): string {
        let element = require('./grid.html').default;
        let style = require('./grid.less');
        return element;
    }
    constructor() {
       super();
    }
    public set ColumnDefinition(v: string) { this._ColumnDefinition = v; } public get ColumnDefinition(): string { return this._ColumnDefinition;} private _ColumnDefinition: string;
    public set RowDefinition(v: string) { this._RowDefinition = v; } public get RowDefinition(): string { return this._RowDefinition;} private _RowDefinition: string;
    public set children(v: ObservableArray<FormBuilderElement>) { this._children = v; } public get children(): ObservableArray<FormBuilderElement> { return this._children;} private _children: ObservableArray<FormBuilderElement>;
}
